import { combineReducers } from "redux";
import  associateStore  from "./associateStoreCode.reducer";
import fortiva from "./fortiva.reducer";

const rootReducer= combineReducers({
    associateStore,
    fortiva
})

export default rootReducer;